import { OrderListItem } from '../../../../../pages/admin-dashboard/orders-management/orders.model';
import { OrderTableRow } from './order-table.model';

function toOrderTableRow(order: OrderListItem, index: number, isArabic: boolean): OrderTableRow {
  const region = isArabic ? order.region?.titleAr : order.region?.titleEn;
  const owner = order.pharmacy?.pharmacyOwner?.fullName ?? '—';
  const formattedId = order.id ? `#${order.id}` : '—';

  return {
    id: order.id,
    orderId: formattedId,
    pharmacyOwnerRegion: region ? `${owner} - ${region}` : owner,
    status: {
      titleEn: order.status?.titleEn ?? '—',
      titleAr: order.status?.titleAr ?? '—',
    },
    totalItems: order.totalItems,
    totalPharmacyPrice: order.totalPharmacyPrice?.toString() ?? '0',
    createdOn: order.createdOn,
    createdBy: order.createdBy?.fullName ?? '—',
    lastModifiedOn: order.lastModifiedOn ?? null,
    lastModifiedBy: order.lastModifiedBy?.fullName ?? null,
  };
}

export function toOrderTableRows(orders: OrderListItem[], isArabic: boolean): OrderTableRow[] {
  return orders.map((o, i) => toOrderTableRow(o, i, isArabic));
}
